import { render, staticRenderFns } from "./PPIntroduction.vue?vue&type=template&id=50565e04"
import script from "./PPIntroduction.vue?vue&type=script&lang=js"
export * from "./PPIntroduction.vue?vue&type=script&lang=js"
import style0 from "./PPIntroduction.vue?vue&type=style&index=0&id=50565e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports